import { useEffect } from 'react';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  type = 'website',
  author = 'सीधी सोच सीधी बात',
  siteName = 'सीधी सोच सीधी बात - संजय ह. परदेशी'
}) => {
  const defaultDescription = 'सीधी सोच सीधी बात - समाज के कल्याण के लिए समर्पित संगठन। हमारे कार्यक्रम, सेवाएं और जनसेवा के प्रयासों के बारे में जानें।';
  const defaultKeywords = 'सीधी सोच सीधी बात, जनसेवा, समाज कल्याण, सामाजिक विकास, भारत, नई दिल्ली, सामाजिक कार्य, जनहित';
  const defaultImage = '/images/logo.png';
  const baseUrl = process.env.REACT_APP_BASE_URL || 'https://sidhisochsidhibaat.com';

  useEffect(() => {
    // Set document title
    document.title = title ? `${title} - ${siteName}` : siteName;
    
    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = description || defaultDescription;
    
    // Set meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.content = keywords || defaultKeywords;
    
    // Set meta author
    let metaAuthor = document.querySelector('meta[name="author"]');
    if (!metaAuthor) {
      metaAuthor = document.createElement('meta');
      metaAuthor.name = 'author';
      document.head.appendChild(metaAuthor);
    }
    metaAuthor.content = author;
    
    // Set Open Graph meta tags
    const ogTags = [
      { property: 'og:title', content: title ? `${title} - ${siteName}` : siteName },
      { property: 'og:description', content: description || defaultDescription },
      { property: 'og:type', content: type },
      { property: 'og:url', content: url ? `${baseUrl}${url}` : baseUrl },
      { property: 'og:image', content: image ? `${baseUrl}${image}` : `${baseUrl}${defaultImage}` },
      { property: 'og:site_name', content: siteName },
      { property: 'og:locale', content: 'hi_IN' }
    ];
    
    ogTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[property="${tag.property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', tag.property);
        document.head.appendChild(metaTag);
      }
      metaTag.content = tag.content;
    });
    
    // Set Twitter Card meta tags
    const twitterTags = [
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title ? `${title} - ${siteName}` : siteName },
      { name: 'twitter:description', content: description || defaultDescription },
      { name: 'twitter:image', content: image ? `${baseUrl}${image}` : `${baseUrl}${defaultImage}` }
    ];
    
    twitterTags.forEach(tag => {
      let metaTag = document.querySelector(`meta[name="${tag.name}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.name = tag.name;
        document.head.appendChild(metaTag);
      }
      metaTag.content = tag.content;
    });
    
    // Set canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = url ? `${baseUrl}${url}` : baseUrl;
    
  }, [title, description, keywords, image, url, type, author, siteName, baseUrl]);

  // Return null since we're not rendering anything
  return null;
};

export default SEO; 